import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let LabelComp;

class Label extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: LabelComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(
      import(/* webpackChunkName: "components/javascript/zcat-components/label-comp" */
      "../../../components/javascript/zcat-components/label-comp").then(function(res) {
        LabelComp = res.LabelComp;
      })
    );

    
;
  }
}

export { Label };
